import { formatPrice } from "../../../commons/utils/functions/formatPrice";
import { isVariantSelected } from "../../../commons/utils/functions/product";
import styles from "./surplus-product-variants.module.scss";

interface SurplusProductVariantsProps {
  attributes: SurplusProductAttribute[];
  selectedVariants: SurplusProductVariation[];
  setSelectedVariant: (variant: SelectedVariant) => void;
}

const SurplusProductVariants: React.FC<SurplusProductVariantsProps> = ({
  attributes,
  selectedVariants,
  setSelectedVariant,
}: SurplusProductVariantsProps) => {
  const renderLabelTooltip = (minOrder: number, maxOrder: number) => {
    if (minOrder === 0) {
      return <span>Optional{maxOrder && `, max ${maxOrder}`}</span>;
    } else if (minOrder >= maxOrder) {
      return <span>{`Pick ${minOrder}`}</span>;
    } else if (!minOrder && !maxOrder) {
      return <span>Pick 1</span>;
    }
    return <span>{`Pick ${minOrder}, max ${maxOrder}`}</span>;
  };

  return (
    <div className={styles.wrapper}>
      {attributes.map((attribute, index) => (
        <div className={styles.attribute} key={index}>
          <div className={styles.label}>
            {attribute.attribute}: {renderLabelTooltip(attribute.min!, attribute.max!)}
          </div>
          <div className={styles.variants}>
            {attribute.variants.map((variant: SurplusProductVariation, indexVariant: number) => {
              const uniqueIndex = `${index}-${indexVariant}`;
              return (
                <div
                  className={[
                    styles.variant,
                    isVariantSelected({ ...variant, index: uniqueIndex }, selectedVariants) ? styles.active : "",
                  ].join(" ")}
                  key={indexVariant}
                  onClick={() =>
                    setSelectedVariant({
                      ...variant,
                      min: attribute.min!,
                      max: attribute.max!,
                      index: uniqueIndex,
                      isRequired: attribute.isRequired,
                      is_required: attribute.isRequired,
                      is_multiple_choice: attribute.isMultipleChoice,
                      attribute_name: attribute.attribute,
                      attribute_value: variant.variant,
                    })
                  }
                >
                  {variant.variant}{" "}
                  <span className={styles.price}>{variant.price > 0 ? formatPrice(variant.price) : ""}</span>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SurplusProductVariants;
